import type { CreditBlockProduct } from '../../types';

export function subscriptionStageLabel(p: CreditBlockProduct): string {
  return (
    p.subscriptionStage?.trim() ||
    (p.status === 'active'
      ? 'Current Client'
      : p.status === 'cancelled'
        ? 'Cancelled'
        : p.status === 'suspended'
          ? 'Suspended'
          : p.status)
  );
}

export function formatSubDate(iso: string | undefined): string {
  if (!iso) return '—';
  const raw = String(iso).trim();
  if (!raw) return '—';
  if (/^\d{10,13}$/.test(raw)) {
    const n = Number(raw);
    const ms = raw.length === 10 ? n * 1000 : n;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? raw : d.toLocaleDateString();
  }
  // Calendar-day semantics: take the YYYY-MM-DD prefix from any ISO-shaped
  // input and format directly, so "2025-07-16" and "2025-07-16T00:00:00.000Z"
  // both render as 7/16/2025 in every timezone. Without this, midnight-UTC
  // ISO strings from the SF sync render as the prior day in PDT.
  const yyyyMmDd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (yyyyMmDd) {
    const [, y, m, d] = yyyyMmDd;
    return `${m}/${d}/${y}`;
  }
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? raw : d.toLocaleDateString();
}

export function normalizeDateForInput(iso: string | undefined): string {
  if (!iso) return '';
  const raw = String(iso).trim();
  if (!raw) return '';
  if (/^\d{10,13}$/.test(raw)) {
    const n = Number(raw);
    const ms = raw.length === 10 ? n * 1000 : n;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
  }
  const yyyyMmDd = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (yyyyMmDd) return yyyyMmDd[1];
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
}

export const normalizeDisplayToken = (value: unknown): string =>
  String(value ?? '')
    .trim()
    .replace(/__stg3_c$|__stg_c$|__dev_c$|__c$/i, '');

export const subscriptionDisplayLabel = (row: CreditBlockProduct): string => {
  const rec = row as unknown as Record<string, unknown>;
  const fromNumber = normalizeDisplayToken(rec.subscriptionNumber ?? rec.SubscriptionNumber ?? rec.Name__c);
  if (fromNumber) return fromNumber;

  const fromName = normalizeDisplayToken(row.name);
  if (fromName) {
    const cleaned = fromName.replace(/^credit block\s+/i, '').trim();
    if (cleaned) return cleaned;
  }

  return normalizeDisplayToken(row.id) || '—';
};
